export default "__VITE_ASSET__rKJVQj3G__"